import api from "./api";
import {
  ApiResponse,
  PopUp,
  PopUpCreateDTO,
  PopUpFoto,
  PopUpFotoCreateDTO,
  PopUpUpdateDTO,
} from "./types";

export const PopUpPageService = {
  popupListele: async () => {
    const response = await api.get<ApiResponse<PopUp[]>>(
      "/api/Anasayfa/PopupListele"
    );
    return response.data;
  },



  popupDetay: async (id: string) => {
    const response = await api.get<ApiResponse<PopUp>>(
      `/api/Anasayfa/PopupDetay/{id}${id}`
    );
    return response.data;
  },

  popupEkle: async (data: PopUpCreateDTO) => {
    const formData = new FormData();
    formData.append("baslik", data.baslik);
    formData.append("aciklama", data.aciklama);
    formData.append("popupYil", data.popupYil);
    formData.append("onClickUrl", data.onClickUrl || ""); // Güvenli erişim
    if (data.kapakFotoFile) {
      formData.append("PopupGorselForm", data.kapakFotoFile);
    }
    if (data.yatayFotoFile) {
      formData.append("yatayFotoFile", data.yatayFotoFile);
    }
  
    const response = await api.post<ApiResponse<PopUp>>(
      "/api/Anasayfa/PopupEkle",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  popupGuncelle: async (data: PopUpUpdateDTO) => {
    const formData = new FormData();
  
    formData.append("id", data.id);
    formData.append("baslik", data.baslik);
    formData.append("aciklama", data.aciklama);
    formData.append("popupYil", data.popupYil);
    formData.append("popupFotolar", JSON.stringify([]));
  
    // ❗️Yalnızca yeni bir görsel seçildiyse dosyayı gönder
    if (data.kapakFotoFile) {
      formData.append("PopupGorselForm", data.kapakFotoFile);
    }
  
    const response = await api.put<ApiResponse<PopUp>>(
      "/api/Anasayfa/PopupGuncelle",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
  
    return response.data;
  },
  
  

  popupSil: async (id: string) => {
    const encodedId = encodeURIComponent(id);
    const response = await api.delete<ApiResponse<boolean>>(
      `/api/Anasayfa/PopupSil/${encodedId}`
    );
    return response.data;
  },

  popupFotolariDetay: async (popupId: string) => {
    const response = await api.get<ApiResponse<PopUpFoto[]>>(
      `/api/Anasayfa/PopupDetay/${popupId}`
    );
    return response.data;
  },

  popupFotoEkle: async (data: PopUpFotoCreateDTO) => {
    const formData = new FormData();
    formData.append("sira", data.sira.toString());
    formData.append("popupId", data.popupId);
    formData.append("foto", data.foto);

    const response = await api.post<ApiResponse<PopUpFoto>>(
      "/api/Anasayfa/PopupEkle",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  popupFotoSil: async (id: string) => {
    const response = await api.delete<ApiResponse<boolean>>(
      `/api/Anasayfa/PopupSil/${id}`
    );
    return response.data;
  },
};
